import { SOURCE_ID_MAP } from '@/enum/const.js'
import md5 from 'crypto-js/md5'

export default (event, data) => {
  const urlParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
  const TAG = process.env[`VUE_APP_TAG_${urlParams.gid}`]
  const SIG_KEY = process.env[`VUE_APP_SIG_KEY_${urlParams.gid}`]
  const logApi = process.env[`VUE_APP_LOGAGENT_${urlParams.gid}`]
  // v1.0.6
  // 不打点来源: PC官网
  if (urlParams.source_id === SOURCE_ID_MAP.PC_OFFICIAL) return
  const logData = urlParams.logData
  const now = new Date().getTime()
  const signature = md5(TAG + ":" + now + ":" + SIG_KEY)
  const params = {
    // basic
    ...logData.basic,
    event_ts: now,
    log_source: 'wp',
    event: event,

    properties: logData.properties,
    detail: data,
  }
  if (!params.app_id) params.app_id = TAG
  logApi && fetch(
    logApi + "?tag=" + TAG + "&timestamp=" + now + "&signature=" + signature + "&num=1",
    {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    body: JSON.stringify(params)
  })
}
